import axios from 'axios';

function setAuthInterceptor (jwt) {
  backendApi.interceptors.request.use(
    (config) => {
      config.headers['Authorization'] = `Bearer ${ jwt }`;
      return config;
    }, 
    (error) => {
      return Promise.reject(error);
    }
  );
}

const remaxApi = axios.create({
  baseURL: process.env.VUE_APP_REMAX_API,
  headers: {
    'AppId': process.env.VUE_APP_REMAX_APP_ID,
    'AppCredential': process.env.VUE_APP_REMAX_APP_CREDENTIAL,
    'RegionId': process.env.VUE_APP_REMAX_REGION_ID,
  }
});

const backendApi = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_API
});

const remax = {
  getLookUps () {
    return remaxApi.get('/Portals/GetLookUps');
  },

  getSalesPriceRanges () {
    return remaxApi.get('/Portals/GetSalesPriceRanges');
  },

  getLettingPriceRanges () {
    return remaxApi.get('/Portals/GetLettingPriceRanges');
  },

  searchProperties (request) {
    return remaxApi.post('/Portals/GetListings', request);
  },

  getProperty (mls) {
    return remaxApi.get('/Portals/GetFullListing', {
      params: {
        mls
      }
    });
  }
}

const backend = {
  auth: {
    email: {
      login (request) {
        return backendApi.post('/auth/login', request)
          .then(({ data }) => {
            return { data };
          });
      },

      register (request) {
        return backendApi.post('/auth/register', request)
          .then(({ data }) => {
            return { data };
          });
      },

      resetPassword (request) {
        return backendApi.post('/auth/reset-password', request);
      },

      forgotPassword (request) {
        return backendApi.post('/auth/forgot-password', request);
      },

      verify (token) {
        return backendApi.get(`/auth/verify/${ token }`, {
            transformRequest: [(data, headers) => { 
              delete headers.Authorization;
              return data;
            }]
          })
          .then(({ data }) => {
            return { data };
          });
      }
    }
  },

  properties: {
    enquire (request) {
      return backendApi.post('/enquire', request);
    }
  },

  user: {
    getDetails () {
      return backendApi.get('/user')
    },

    likedProperties () {
      return backendApi.get('/user/properties/liked')
    },

    likeProperty (mls) {
      return backendApi.post('/user/properties/liked', {
        property_id: mls
      })
    },

    unlikeProperty (mls) {
      return backendApi.delete(`/user/properties/liked/${ mls }`)
    },

    dislikeProperty (mls) {
      return backendApi.post('/user/properties/disliked', {
        property_id: mls
      })
    }
  }
}

export {
  remax,
  backend,
  setAuthInterceptor
};